import React from 'react';
import { Box, Typography, Grid, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Views = ({ viewValue }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    if (
        !viewValue ||
        typeof viewValue.yearCountSum !== 'number' ||
        typeof viewValue.monthSum !== 'number' ||
        typeof viewValue.daySum !== 'number'
    ) {
        return <div>{t('dataUnavailable')}</div>;
    }

    return (
        <Box
            style={{
                marginTop: 60,
                marginBottom: 60,
            }}
        >
            <Grid container spacing={isSmallScreen ? 2 : 4}>
                <Grid item xs={12} md={8}>
                    <Box
                        style={{
                            borderRight: isSmallScreen ? 'none' : '1px solid #d8d5d5',
                            padding: 20,
                        }}
                    >
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: 20,
                            }}
                        >
                            <Box
                                style={{
                                    width: '20%',
                                    borderTop: '8px solid',
                                }}
                                className="!border-primary-600"
                            ></Box>
                            <Box
                                style={{
                                    width: '80%',
                                    borderTop: '2px solid #d8d5d5',
                                }}
                            ></Box>
                        </Box>
                        <Typography
                            style={{
                                fontSize: 25,
                                fontWeight: 700,
                                marginBottom: 20,
                                fontFamily: '"Manrope", sans-serif',
                            }}
                            className='text-primary-800'
                        >
                            {t('access')}
                        </Typography>
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 10,
                            }}
                        >
                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                <Box
                                    style={{
                                        height: 16,
                                        width: 16,
                                        backgroundImage: 'url(/icon/day.png)',
                                        marginRight: 5,
                                    }}
                                ></Box>
                                <Typography
                                    style={{
                                        fontSize: 20,
                                        fontWeight: 400,
                                        fontFamily: '"Manrope", sans-serif',
                                    }}
                                >
                                    {t('today')}
                                </Typography>
                            </Box>
                            <Typography
                                style={{
                                    fontSize: 20,
                                    fontWeight: 400,
                                    fontFamily: '"Manrope", sans-serif',
                                }}
                            >
                                {viewValue.daySum}
                            </Typography>
                        </Box>
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 10,
                            }}
                        >
                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                <Box
                                    style={{
                                        height: 16,
                                        width: 16,
                                        backgroundImage: 'url(/icon/week.png)',
                                        marginRight: 5,
                                    }}
                                ></Box>
                                <Typography
                                    style={{
                                        fontSize: 20,
                                        fontWeight: 400,
                                        fontFamily: '"Manrope", sans-serif',
                                    }}
                                >
                                    {t('week')}
                                </Typography>
                            </Box>
                            <Typography
                                style={{
                                    fontSize: 20,
                                    fontWeight: 400,
                                    fontFamily: '"Manrope", sans-serif',
                                }}
                            >
                                {viewValue.weekSum}
                            </Typography>
                        </Box>
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 10,
                            }}
                        >
                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                <Box
                                    style={{
                                        height: 16,
                                        width: 16,
                                        backgroundImage: 'url(/icon/month.png)',
                                        marginRight: 5,
                                    }}
                                ></Box>
                                <Typography
                                    style={{
                                        fontSize: 20,
                                        fontWeight: 400,
                                        fontFamily: '"Manrope", sans-serif',
                                    }}
                                >
                                    {t('month')}
                                </Typography>
                            </Box>
                            <Typography
                                style={{
                                    fontSize: 20,
                                    fontWeight: 400,
                                    fontFamily: '"Manrope", sans-serif',
                                }}
                            >
                                {viewValue.monthSum}
                            </Typography>
                        </Box>
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 10,
                            }}
                        >
                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                <Box
                                    style={{
                                        height: 16,
                                        width: 16,
                                        backgroundImage: 'url(/icon/year.png)',
                                        marginRight: 5,
                                    }}
                                ></Box>
                                <Typography
                                    style={{
                                        fontSize: 20,
                                        fontWeight: 400,
                                        fontFamily: '"Manrope", sans-serif',
                                    }}
                                >
                                    {t('total')}
                                </Typography>
                            </Box>
                            <Typography
                                style={{
                                    fontSize: 20,
                                    fontWeight: 400,
                                    fontFamily: '"Manrope", sans-serif',
                                }}
                            >
                                {viewValue.yearCountSum}
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography
                        style={{
                            fontSize: 25,
                            fontWeight: 500,
                            marginBottom: 10,
                            fontFamily: '"Manrope", sans-serif',
                        }}
                    >
                        {t('social')}
                    </Typography>
                    <Box>
                        <iframe
                            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D61573684527461&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                            style={{
                                width: '100%',
                                height: 331,
                                border: 'none',
                                overflow: 'hidden',
                            }}
                            scrolling="no"
                            frameBorder="0"
                            allow="encrypted-media"
                        ></iframe>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Views;
